// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

export const travelStatus = {
    NEW: "New",
    INPROGRESS: "In Progress",
    COMPLETED: "Completed",
    ONHOLD: "On Hold",
    CANCELLED: "Cancelled",
    EXTENDED: "Extended"
}

export const hotelStatus = {
    CONFIRMED: "Confirmed",
    TENTATIVE: "Tentative",
    ONHOLD: "On Hold",
    CANCELLED: "Cancelled",
    DELETED: "Deleted"
}

export const visaStatus = {
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    EXPIRED: "Expired"
}

export const travelDocumentStatus = {
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    EXPIRED: "Expired"
}

export const travelDocumentTypes = {
    PASSPORT: "Passport",
    DRIVER_LICENSE: "Driver License",
    OTHER_ID_DOCUMENT: "Other ID Document"
}

export const invoiceApproval = {
    COMPLETE: "Complete",
    PENDING: "Pending",
    REJECTED_BY_TRAVEL: "Rejected by travel",
    REJECTED_BY_FINANCE: "Rejected by finance",
    ACCEPTED_BY_TRAVEL: "Accepted by travel",
    ACCEPTED_BY_FINANCE: "Accepted by finance"
}

export const perdiemPaymentNetsuiteStatus = {
    COMPLETE: "Complete",
    PENDING: "Pending"
}

export const perdiemStatus = {
    ACTIVE:"Active"
}

export const order = {
    ASC: "asc",
    DESC: "desc"
}

export const orderBy = {
    PER_DIEM_NUMBER: "per_diem_number",
    TRAVELLER_EMAIL: "traveller_email",
    ADDED_DATE: "added_date"
}

export const perdiemPaymentStatus = {
    ACTIVE:"Active"
}

export const invoiceApprovalLabels = {
    PENDING: "Pending",
    REJECTED: "Rejected",
    APPROVED: "Approved",
    PUSHED: "Pushed"
}

export const perdiemPaymentNetSuiteStatusLabels = {
    PENDING: "Pending",
    PUSHED: "Pushed"
}

export const travelStatusArray = [travelStatus.NEW, travelStatus.INPROGRESS, travelStatus.COMPLETED, travelStatus.ONHOLD, travelStatus.CANCELLED, travelStatus.EXTENDED]

export const hotelStatusArray = [hotelStatus.CONFIRMED, hotelStatus.TENTATIVE, hotelStatus.ONHOLD, hotelStatus.CANCELLED]

export const visaStatusArray = [visaStatus.ACTIVE, visaStatus.INACTIVE, visaStatus.EXPIRED]

export const travelDocumentStatusArray = [travelDocumentStatus.ACTIVE, travelDocumentStatus.INACTIVE, travelDocumentStatus.EXPIRED]

export const travelDocumentTypesArray = [travelDocumentTypes.PASSPORT, travelDocumentTypes.DRIVER_LICENSE, travelDocumentTypes.OTHER_ID_DOCUMENT]

export const perdiemPaymentNetsuiteStatusArray = [perdiemPaymentNetSuiteStatusLabels.PUSHED, perdiemPaymentNetSuiteStatusLabels.PENDING]

export const visaTypes = ["Business/Visit", "Work Permit", "Permenent Residence", "Other"]

export const entryTypes = ["Single", "Double", "Multiple"]

export const monthsArray = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

export const USDCurrency = "USD"

export const travelInvoiceNumberRegex = /^[A-Za-z0-9-]+$/

export const currencyInvoiceCostType = 6;

export const countries = [
    ['AF', 'Afghanistan'],
    ['AL', 'Albania'],
    ['DZ', 'Algeria'],
    ['AS', 'American Samoa'],
    ['AD', 'Andorra'],
    ['AG', 'Angola'],
    ['AI', 'Anguilla'],
    ['AG', 'Antigua & Barbuda'],
    ['AR', 'Argentina'],
    ['AA', 'Armenia'],
    ['AW', 'Aruba'],
    ['AU', 'Australia'],
    ['AT', 'Austria'],
    ['AZ', 'Azerbaijan'],
    ['BS', 'Bahamas'],
    ['BH', 'Bahrain'],
    ['BD', 'Bangladesh'],
    ['BB', 'Barbados'],
    ['BY', 'Belarus'],
    ['BE', 'Belgium'],
    ['BZ', 'Belize'],
    ['BJ', 'Benin'],
    ['BM', 'Bermuda'],
    ['BT', 'Bhutan'],
    ['BO', 'Bolivia'],
    ['BL', 'Bonaire'],
    ['BA', 'Bosnia & Herzegovina'],
    ['BW', 'Botswana'],
    ['BR', 'Brazil'],
    ['BC', 'British Indian Ocean Ter'],
    ['BN', 'Brunei'],
    ['BG', 'Bulgaria'],
    ['BF', 'Burkina Faso'],
    ['BI', 'Burundi'],
    ['KH', 'Cambodia'],
    ['CM', 'Cameroon'],
    ['CA', 'Canada'],
    ['IC', 'Canary Islands'],
    ['CV', 'Cape Verde'],
    ['KY', 'Cayman Islands'],
    ['CF', 'Central African Republic'],
    ['TD', 'Chad'],
    ['CD', 'Channel Islands'],
    ['CL', 'Chile'],
    ['CN', 'China'],
    ['CI', 'Christmas Island'],
    ['CS', 'Cocos Island'],
    ['CO', 'Colombia'],
    ['CC', 'Comoros'],
    ['CG', 'Congo'],
    ['CK', 'Cook Islands'],
    ['CR', 'Costa Rica'],
    ['CT', 'Cote D\'Ivoire'],
    ['HR', 'Croatia'],
    ['CU', 'Cuba'],
    ['CB', 'Curacao'],
    ['CY', 'Cyprus'],
    ['CZ', 'Czech Republic'],
    ['DK', 'Denmark'],
    ['DJ', 'Djibouti'],
    ['DM', 'Dominica'],
    ['DO', 'Dominican Republic'],
    ['TM', 'East Timor'],
    ['EC', 'Ecuador'],
    ['EG', 'Egypt'],
    ['SV', 'El Salvador'],
    ['GQ', 'Equatorial Guinea'],
    ['ER', 'Eritrea'],
    ['EE', 'Estonia'],
    ['ET', 'Ethiopia'],
    ['FA', 'Falkland Islands'],
    ['FO', 'Faroe Islands'],
    ['FJ', 'Fiji'],
    ['FI', 'Finland'],
    ['FR', 'France'],
    ['GF', 'French Guiana'],
    ['PF', 'French Polynesia'],
    ['FS', 'French Southern Ter'],
    ['GA', 'Gabon'],
    ['GM', 'Gambia'],
    ['GE', 'Georgia'],
    ['DE', 'Germany'],
    ['GH', 'Ghana'],
    ['GI', 'Gibraltar'],
    ['GB', 'Great Britain'],
    ['GR', 'Greece'],
    ['GL', 'Greenland'],
    ['GD', 'Grenada'],
    ['GP', 'Guadeloupe'],
    ['GU', 'Guam'],
    ['GT', 'Guatemala'],
    ['GN', 'Guinea'],
    ['GY', 'Guyana'],
    ['HT', 'Haiti'],
    ['HW', 'Hawaii'],
    ['HN', 'Honduras'],
    ['HK', 'Hong Kong'],
    ['HU', 'Hungary'],
    ['IS', 'Iceland'],
    ['IN', 'India'],
    ['ID', 'Indonesia'],
    ['IA', 'Iran'],
    ['IQ', 'Iraq'],
    ['IR', 'Ireland'],
    ['IM', 'Isle of Man'],
    ['IL', 'Israel'],
    ['IT', 'Italy'],
    ['JM', 'Jamaica'],
    ['JP', 'Japan'],
    ['JO', 'Jordan'],
    ['KZ', 'Kazakhstan'],
    ['KE', 'Kenya'],
    ['KI', 'Kiribati'],
    ['NK', 'Korea North'],
    ['KS', 'Korea South'],
    ['KW', 'Kuwait'],
    ['KG', 'Kyrgyzstan'],
    ['LA', 'Laos'],
    ['LV', 'Latvia'],
    ['LB', 'Lebanon'],
    ['LS', 'Lesotho'],
    ['LR', 'Liberia'],
    ['LY', 'Libya'],
    ['LI', 'Liechtenstein'],
    ['LT', 'Lithuania'],
    ['LU', 'Luxembourg'],
    ['MO', 'Macau'],
    ['MK', 'Macedonia'],
    ['MG', 'Madagascar'],
    ['MY', 'Malaysia'],
    ['MW', 'Malawi'],
    ['MV', 'Maldives'],
    ['ML', 'Mali'],
    ['MT', 'Malta'],
    ['MH', 'Marshall Islands'],
    ['MQ', 'Martinique'],
    ['MR', 'Mauritania'],
    ['MU', 'Mauritius'],
    ['ME', 'Mayotte'],
    ['MX', 'Mexico'],
    ['MI', 'Midway Islands'],
    ['MD', 'Moldova'],
    ['MC', 'Monaco'],
    ['MN', 'Mongolia'],
    ['MS', 'Montserrat'],
    ['MA', 'Morocco'],
    ['MZ', 'Mozambique'],
    ['MM', 'Myanmar'],
    ['NA', 'Nambia'],
    ['NU', 'Nauru'],
    ['NP', 'Nepal'],
    ['AN', 'Netherland Antilles'],
    ['NL', 'Netherlands (Holland'],
    ['NV', 'Nevis'],
    ['NC', 'New Caledonia'],
    ['NZ', 'New Zealand'],
    ['NI', 'Nicaragua'],
    ['NE', 'Niger'],
    ['NG', 'Nigeria'],
    ['NW', 'Niue'],
    ['NF', 'Norfolk Island'],
    ['NO', 'Norway'],
    ['OM', 'Oman'],
    ['PK', 'Pakistan'],
    ['PW', 'Palau Island'],
    ['PS', 'Palestine'],
    ['PA', 'Panama'],
    ['PG', 'Papua New Guinea'],
    ['PY', 'Paraguay'],
    ['PE', 'Peru'],
    ['PH', 'Philippines'],
    ['PO', 'Pitcairn Island'],
    ['PL', 'Poland'],
    ['PT', 'Portugal'],
    ['PR', 'Puerto Rico'],
    ['QA', 'Qatar'],
    ['ME', 'Republic of Montenegro'],
    ['RS', 'Republic of Serbia'],
    ['RE', 'Reunion'],
    ['RO', 'Romania'],
    ['RU', 'Russia'],
    ['RW', 'Rwanda'],
    ['NT', 'St Barthelemy'],
    ['EU', 'St Eustatius'],
    ['HE', 'St Helena'],
    ['KN', 'St Kitts-Nevis'],
    ['LC', 'St Lucia'],
    ['MB', 'St Maarten'],
    ['PM', 'St Pierre & Miquelon'],
    ['VC', 'St Vincent & Grenadines'],
    ['SP', 'Saipan'],
    ['SO', 'Samoa'],
    ['AS', 'Samoa American'],
    ['SM', 'San Marino'],
    ['ST', 'Sao Tome & Principe'],
    ['SA', 'Saudi Arabia'],
    ['SN', 'Senegal'],
    ['RS', 'Serbia'],
    ['SC', 'Seychelles'],
    ['SL', 'Sierra Leone'],
    ['SG', 'Singapore'],
    ['SK', 'Slovakia'],
    ['SI', 'Slovenia'],
    ['SB', 'Solomon Islands'],
    ['OI', 'Somalia'],
    ['ZA', 'South Africa'],
    ['ES', 'Spain'],
    ['LK', 'Sri Lanka'],
    ['SD', 'Sudan'],
    ['SR', 'Suriname'],
    ['SZ', 'Swaziland'],
    ['SE', 'Sweden'],
    ['CH', 'Switzerland'],
    ['SY', 'Syria'],
    ['TA', 'Tahiti'],
    ['TW', 'Taiwan'],
    ['TJ', 'Tajikistan'],
    ['TZ', 'Tanzania'],
    ['TH', 'Thailand'],
    ['TG', 'Togo'],
    ['TK', 'Tokelau'],
    ['TO', 'Tonga'],
    ['TT', 'Trinidad & Tobago'],
    ['TN', 'Tunisia'],
    ['TR', 'Turkey'],
    ['TU', 'Turkmenistan'],
    ['TC', 'Turks & Caicos Is'],
    ['TV', 'Tuvalu'],
    ['UG', 'Uganda'],
    ['UA', 'Ukraine'],
    ['AE', 'United Arab Emirates'],
    ['UK', 'United Kingdom'],
    ['US', 'United States of America'],
    ['UY', 'Uruguay'],
    ['UZ', 'Uzbekistan'],
    ['VU', 'Vanuatu'],
    ['VS', 'Vatican City State'],
    ['VE', 'Venezuela'],
    ['VN', 'Vietnam'],
    ['VB', 'Virgin Islands (Brit)'],
    ['VA', 'Virgin Islands (USA)'],
    ['WK', 'Wake Island'],
    ['WF', 'Wallis & Futana Is'],
    ['YE', 'Yemen'],
    ['ZR', 'Zaire'],
    ['ZM', 'Zambia'],
    ['ZW', 'Zimbabwe']
];

export const invoiceCurrencyTypes = [
    ['LKR', 'Sri Lankan Rupee'],
    ['USD', 'United States Dollar']
];

export const travelCardCurrencyTypes = [
    ['USD', 'United States Dollar'],
    ['GBP', 'British Pound Sterling']
];

export const currencyTypes = [
    ['AED', 'United Arab Emirates Dirham'],
    ['AFN', 'Afghan Afghani'],
    ['ALL', 'Albanian Lek'],
    ['AMD', 'Armenian Dram'],
    ['ANG', 'Netherlands Antillean Guilder'],
    ['AOA', 'Angolan Kwanza'],
    ['ARS', 'Argentine Peso'],
    ['AUD', 'Australian Dollar'],
    ['AWG', 'Aruban Florin'],
    ['AZN', 'Azerbaijani Manat'],
    ['BAM', 'Bosnia-Herzegovina Convertible Mark'],
    ['BBD', 'Barbadian Dollar'],
    ['BDT', 'Bangladeshi Taka'],
    ['BGN', 'Bulgarian Lev'],
    ['BHD', 'Bahraini Dinar'],
    ['BIF', 'Burundian Franc'],
    ['BMD', 'Bermudan Dollar'],
    ['BND', 'Brunei Dollar'],
    ['BOB', 'Bolivian Boliviano'],
    ['BRL', 'Brazilian Real'],
    ['BSD', 'Bahamian Dollar'],
    ['BTC', 'Bitcoin'],
    ['BTN', 'Bhutanese Ngultrum'],
    ['BWP', 'Botswanan Pula'],
    ['BYR', 'Belarusian Ruble'],
    ['BZD', 'Belize Dollar'],
    ['CAD', 'Canadian Dollar'],
    ['CDF', 'Congolese Franc'],
    ['CHF', 'Swiss Franc'],
    ['CLF', 'Chilean Unit of Account (UF)'],
    ['CLP', 'Chilean Peso'],
    ['CNY', 'Chinese Yuan'],
    ['COP', 'Colombian Peso'],
    ['CRC', 'Costa Rican Col\u00f3n'],
    ['CUC', 'Cuban Convertible Peso'],
    ['CUP', 'Cuban Peso'],
    ['CVE', 'Cape Verdean Escudo'],
    ['CZK', 'Czech Republic Koruna'],
    ['DJF', 'Djiboutian Franc'],
    ['DKK', 'Danish Krone'],
    ['DOP', 'Dominican Peso'],
    ['DZD', 'Algerian Dinar'],
    ['EEK', 'Estonian Kroon'],
    ['EGP', 'Egyptian Pound'],
    ['ERN', 'Eritrean Nakfa'],
    ['ETB', 'Ethiopian Birr'],
    ['EUR', 'Euro'],
    ['FJD', 'Fijian Dollar'],
    ['FKP', 'Falkland Islands Pound'],
    ['GBP', 'British Pound Sterling'],
    ['GEL', 'Georgian Lari'],
    ['GGP', 'Guernsey Pound'],
    ['GHS', 'Ghanaian Cedi'],
    ['GIP', 'Gibraltar Pound'],
    ['GMD', 'Gambian Dalasi'],
    ['GNF', 'Guinean Franc'],
    ['GTQ', 'Guatemalan Quetzal'],
    ['GYD', 'Guyanaese Dollar'],
    ['HKD', 'Hong Kong Dollar'],
    ['HNL', 'Honduran Lempira'],
    ['HRK', 'Croatian Kuna'],
    ['HTG', 'Haitian Gourde'],
    ['HUF', 'Hungarian Forint'],
    ['IDR', 'Indonesian Rupiah'],
    ['ILS', 'Israeli New Sheqel'],
    ['IMP', 'Manx pound'],
    ['INR', 'Indian Rupee'],
    ['IQD', 'Iraqi Dinar'],
    ['IRR', 'Iranian Rial'],
    ['ISK', 'Icelandic Kr\u00f3na'],
    ['JEP', 'Jersey Pound'],
    ['JMD', 'Jamaican Dollar'],
    ['JOD', 'Jordanian Dinar'],
    ['JPY', 'Japanese Yen'],
    ['KES', 'Kenyan Shilling'],
    ['KGS', 'Kyrgystani Som'],
    ['KHR', 'Cambodian Riel'],
    ['KMF', 'Comorian Franc'],
    ['KPW', 'North Korean Won'],
    ['KRW', 'South Korean Won'],
    ['KWD', 'Kuwaiti Dinar'],
    ['KYD', 'Cayman Islands Dollar'],
    ['KZT', 'Kazakhstani Tenge'],
    ['LAK', 'Laotian Kip'],
    ['LBP', 'Lebanese Pound'],
    ['LKR', 'Sri Lankan Rupee'],
    ['LRD', 'Liberian Dollar'],
    ['LSL', 'Lesotho Loti'],
    ['LTL', 'Lithuanian Litas'],
    ['LVL', 'Latvian Lats'],
    ['LYD', 'Libyan Dinar'],
    ['MAD', 'Moroccan Dirham'],
    ['MDL', 'Moldovan Leu'],
    ['MGA', 'Malagasy Ariary'],
    ['MKD', 'Macedonian Denar'],
    ['MMK', 'Myanma Kyat'],
    ['MNT', 'Mongolian Tugrik'],
    ['MOP', 'Macanese Pataca'],
    ['MRO', 'Mauritanian Ouguiya'],
    ['MTL', 'Maltese Lira'],
    ['MUR', 'Mauritian Rupee'],
    ['MVR', 'Maldivian Rufiyaa'],
    ['MWK', 'Malawian Kwacha'],
    ['MXN', 'Mexican Peso'],
    ['MYR', 'Malaysian Ringgit'],
    ['MZN', 'Mozambican Metical'],
    ['NAD', 'Namibian Dollar'],
    ['NGN', 'Nigerian Naira'],
    ['NIO', 'Nicaraguan C\u00f3rdoba'],
    ['NOK', 'Norwegian Krone'],
    ['NPR', 'Nepalese Rupee'],
    ['NZD', 'New Zealand Dollar'],
    ['OMR', 'Omani Rial'],
    ['PAB', 'Panamanian Balboa'],
    ['PEN', 'Peruvian Nuevo Sol'],
    ['PGK', 'Papua New Guinean Kina'],
    ['PHP', 'Philippine Peso'],
    ['PKR', 'Pakistani Rupee'],
    ['PLN', 'Polish Zloty'],
    ['PYG', 'Paraguayan Guarani'],
    ['QAR', 'Qatari Rial'],
    ['RON', 'Romanian Leu'],
    ['RSD', 'Serbian Dinar'],
    ['RUB', 'Russian Ruble'],
    ['RWF', 'Rwandan Franc'],
    ['SAR', 'Saudi Riyal'],
    ['SBD', 'Solomon Islands Dollar'],
    ['SCR', 'Seychellois Rupee'],
    ['SDG', 'Sudanese Pound'],
    ['SEK', 'Swedish Krona'],
    ['SGD', 'Singapore Dollar'],
    ['SHP', 'Saint Helena Pound'],
    ['SLL', 'Sierra Leonean Leone'],
    ['SOS', 'Somali Shilling'],
    ['SRD', 'Surinamese Dollar'],
    ['STD', 'S\u00e3o Tom\u00e9 and Pr\u00edncipe Dobra'],
    ['SVC', 'Salvadoran Col\u00f3n'],
    ['SYP', 'Syrian Pound'],
    ['SZL', 'Swazi Lilangeni'],
    ['THB', 'Thai Baht'],
    ['TJS', 'Tajikistani Somoni'],
    ['TMT', 'Turkmenistani Manat'],
    ['TND', 'Tunisian Dinar'],
    ['TOP', 'Tongan Pa\u02bbanga'],
    ['TRY', 'Turkish Lira'],
    ['TTD', 'Trinidad and Tobago Dollar'],
    ['TWD', 'New Taiwan Dollar'],
    ['TZS', 'Tanzanian Shilling'],
    ['UAH', 'Ukrainian Hryvnia'],
    ['UGX', 'Ugandan Shilling'],
    ['USD', 'United States Dollar'],
    ['UYU', 'Uruguayan Peso'],
    ['UZS', 'Uzbekistan Som'],
    ['VEF', 'Venezuelan Bol\u00edvar Fuerte'],
    ['VND', 'Vietnamese Dong'],
    ['VUV', 'Vanuatu Vatu'],
    ['WST', 'Samoan Tala'],
    ['XAF', 'CFA Franc BEAC'],
    ['XAG', 'Silver (troy ounce)'],
    ['XAU', 'Gold (troy ounce)'],
    ['XCD', 'East Caribbean Dollar'],
    ['XDR', 'Special Drawing Rights'],
    ['XOF', 'CFA Franc BCEAO'],
    ['XPD', 'Palladium Ounce'],
    ['XPF', 'CFP Franc'],
    ['XPT', 'Platinum Ounce'],
    ['YER', 'Yemeni Rial'],
    ['ZAR', 'South African Rand'],
    ['ZMK', 'Zambian Kwacha (pre-2013)'],
    ['ZMW', 'Zambian Kwacha'],
    ['ZWL', 'Zimbabwean Dollar']
];